import { render } from "./BeaconPurposeDetail.vue?vue&type=template&id=e6545862"
import script from "./BeaconPurposeDetail.vue?vue&type=script&lang=js"
export * from "./BeaconPurposeDetail.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__